@if (showTerug()) {
	<app-button (clickit)="goBack()" buttonType="text" icon="chevron-left">Terug</app-button>
}
@if ((currentSelection | async) && showSelection()) {
	<app-filter-label-details-list></app-filter-label-details-list>
}
<div class="rechts">
	@if (showSelection() && adHocSelection()) {
		<div class="save-selection-button" (click)="slaSelectieOp()">
			<app-icon name="add-user" color="primary-1" size="small"></app-icon>
			<span>{{ getSaveSelectionLabel() }}</span>
		</div>
	}
	<ng-content></ng-content>
</div>
